import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const POSPage = lazy(() => import('../pages/pos/page'));
const VentasPage = lazy(() => import('../pages/ventas/page'));
const InventarioPage = lazy(() => import('../pages/inventario/page'));
const ClientesPage = lazy(() => import('../pages/clientes/page'));
const IngresosPage = lazy(() => import('../pages/ingresos/page'));
const CarteraPage = lazy(() => import('../pages/cartera/page'));
const ReportesPage = lazy(() => import('../pages/reportes/page'));
const UsuariosPage = lazy(() => import('../pages/usuarios/page'));
const ConfiguracionPage = lazy(() => import('../pages/configuracion/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const LandingPage = lazy(() => import('../pages/landing/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const RecibosPage = lazy(() => import('../pages/recibos/page'));

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <HomePage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/pos',
    element: (
      <ProtectedRoute>
        <POSPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/ventas',
    element: (
      <ProtectedRoute>
        <VentasPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/inventario',
    element: (
      <ProtectedRoute>
        <InventarioPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/clientes',
    element: (
      <ProtectedRoute>
        <ClientesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/ingresos',
    element: (
      <ProtectedRoute>
        <IngresosPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/cartera',
    element: (
      <ProtectedRoute>
        <CarteraPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/reportes',
    element: (
      <ProtectedRoute>
        <ReportesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/usuarios',
    element: (
      <ProtectedRoute>
        <UsuariosPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/configuracion',
    element: (
      <ProtectedRoute>
        <ConfiguracionPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/recibos',
    element: (
      <ProtectedRoute>
        <RecibosPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/landing',
    element: (
      <ProtectedRoute requireSuperadmin={true}>
        <LandingPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin',
    element: (
      <ProtectedRoute requireSuperadmin={true}>
        <AdminPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/404',
    element: <NotFoundPage />,
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
];

export default routes;